import { setMyCommunityCurrView } from "@/redux/slices";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { USERS } from "../../consts";

const useAddEditUser = () => {
  const dispatch = useDispatch();
  const isView = true;
  const [currentStep, setCurrentStep] = useState<number>(1);

  const onNextStepClick = () => {
    setCurrentStep(currentStep + 1);
  };

  const onPreviousStepClick = () => {
    setCurrentStep(currentStep - 1);
  };

  const onBackClick = () => {
    dispatch(setMyCommunityCurrView(USERS));
  };

  const onStepperClick = (curr_step: number) => {
    setCurrentStep(curr_step);
  };

  return {
    currentStep,
    setCurrentStep,
    onNextStepClick,
    onBackClick,
    isView,
    onStepperClick,
    onPreviousStepClick,
  };
};

export default useAddEditUser;
